import { render, staticRenderFns } from "./IntroductoryCard.vue?vue&type=template&id=7109112a"
import script from "./IntroductoryCard.vue?vue&type=script&lang=js"
export * from "./IntroductoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports